/**
 * This File Should only contain filter functions for String
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.50.2}
 */
/**
 * Convert Every start of word into uppercase
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.50.2}
 * @param {string} value string value
 *
 * @return {string}
 */
export function upcase(value) {
    if (!value) {
        return '';
    }
    return value
        .replace(/_/g, ' ')
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
}
